"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDashboardInsightExecution = void 0;
var tslib_1 = require("tslib");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var converters_1 = require("../../converters");
var utils_1 = require("../utils");
/**
 * Hook allowing to get execution for particular insight widget.
 * @param config - configuration of the hook
 * @internal
 */
function useDashboardInsightExecution(config) {
    var _this = this;
    var backend = config.backend, workspace = config.workspace, insightWidget = config.insightWidget, insight = config.insight, filters = config.filters, filterContext = config.filterContext;
    var effectiveBackend = sdk_ui_1.useBackend(backend);
    var effectiveWorkspace = sdk_ui_1.useWorkspace(workspace);
    utils_1.backendInvariant(effectiveBackend, "useDashboardInsightExecution");
    utils_1.workspaceInvariant(effectiveWorkspace, "useDashboardInsightExecution");
    var promise = insight && insightWidget
        ? function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var inputFilters, relevantFilters;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        inputFilters = filters
                            ? converters_1.filterContextItemsToFiltersForWidget(filters, insightWidget)
                            : converters_1.filterContextToFiltersForWidget(filterContext, insightWidget);
                        return [4 /*yield*/, effectiveBackend
                                .workspace(effectiveWorkspace)
                                .dashboards()
                                .getResolvedFiltersForWidget(insightWidget, inputFilters)];
                    case 1:
                        relevantFilters = (_a.sent());
                        return [2 /*return*/, effectiveBackend
                                .workspace(effectiveWorkspace)
                                .execution()
                                .forInsight(insight, relevantFilters)];
                }
            });
        }); }
        : null;
    return sdk_ui_1.useCancelablePromise({ promise: promise }, [
        effectiveBackend,
        effectiveWorkspace,
        insight,
        insightWidget,
        filters,
        filterContext,
    ]);
}
exports.useDashboardInsightExecution = useDashboardInsightExecution;
//# sourceMappingURL=useDashboardInsightExecution.js.map